import * as React from "react";
import { TableWrapper } from "../styles";
import { ChargeStatus } from "@nkr/enums/index";
import { IFile } from '../file';
import UploadFile from "../upload-file";
import { InputGroup, Label, Table } from "react-bootstrap";

interface IProps {
    centerId: number,
    asaUnitPrice: number,
    asaUnitCount: string,
    validAsaUnitCount: boolean,
    physicianCharges: number,
    hospitalCharges: string,
    validHospitalCharges: boolean,
    hospitalChargesFile: string,
    selectedHospitalChargesFile: IFile,
    validHospitalChargesFile: boolean,
    hospitalChargeStatus: ChargeStatus,
    hospitalChargeComments: string,
    anesthesiaChargesFile: string,
    selectedAnesthesiaChargesFile: IFile,
    validAnesthesiaChargesFile: boolean,
    anesthesiaChargeStatus: ChargeStatus,
    anesthesiaChargeComments: string,
    recipientCenter: string,
    disputedBy: string,
    viewOnly: boolean,
    dirty: boolean,
    onHospitalChargesChange: (cost: string) => void
    onHospicalChargesFileChange: (file: File, type: string) => void,
    onAnesthesiaChargesFileChange: (file: File, type: string) => void,
    onAsaUnitCountChange: (asaUnitsCount: string) => void,
    onEditMedicareParticipating: () => void
}

class Global extends React.Component<IProps, {}> {
    handleHospitalChargesFileChange = (file: File) => {
        this.props.onHospicalChargesFileChange(file, 'hospital-charges');
    }

    handleHospitalChargesChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.props.onHospitalChargesChange(e.currentTarget.value);
    }

    handleAsaUnitCountChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.props.onAsaUnitCountChange(e.currentTarget.value);
    }

    handleAnesthesiaChargesFileChange = (file: File) => {
        this.props.onAnesthesiaChargesFileChange(file, 'anesthesia-charges');
    }

    render = () => {
        const physicianCharges = this.props.physicianCharges;
        const physicianChargesTotal = this.props.physicianCharges * 1.5;

        const { hospitalCharges, validHospitalCharges, asaUnitPrice, asaUnitCount, validAsaUnitCount, anesthesiaChargeStatus,
            anesthesiaChargeComments, hospitalChargeStatus, hospitalChargeComments, recipientCenter } = this.props;

        const anesthesiaTotal = asaUnitPrice * (validAsaUnitCount ? parseFloat(asaUnitCount) : 0);

        const totalCharges = physicianCharges + anesthesiaTotal + (validHospitalCharges ? parseFloat(hospitalCharges) : 0);

        const disputedBy = this.props.disputedBy != '' ? `${this.props.disputedBy} @ ${recipientCenter}` : recipientCenter;

        const disableAnesthesiaFileUpload = this.props.viewOnly;

        const anesthesiaClassName = anesthesiaChargeStatus == ChargeStatus.Disputed ? 'no-border' : ''
        const hospitalClassName = hospitalChargeStatus == ChargeStatus.Disputed ? 'no-border' : ''

        return (
            <>
                <div style={{ marginBottom: 10 }}>Non SBS, Private-Insurance, Global</div>

                <ol style={{ listStyle: "decimal", marginBottom: 25 }}>
                    <li>
                        <strong>Physician Donor Nephrectomy:</strong>
                        <ol style={{ listStyle: "upper-alpha" }}>
                            <li>
                                Private insurance is primary and there is a global arrangement, then the donor surgeon services shall be billed to the
                                Recipient Center at 150% of Medicare participating, and the donor anesthesiologist services shall be billed to the
                                Recipient Center at $65.29/ASA unit.
                            </li>
                        </ol>
                    </li>
                    <li style={{ marginTop: 5 }}>
                        <strong>Hospital Donor Nephrectomy:</strong>
                        <ol style={{ listStyle: "upper-alpha" }}>
                            <li>
                                If a center is not subject to the SBS the Donor Center shall bill the Recipient Center for the donor organ recovery cost
                                by providing a copy of their most recently filed Medicare Cost Report, Worksheet D-4, Part I, which documents the cost
                                per day and the appropriate cost to charge ratios along with a worksheet that reduces the Donor Center bill from charges to cost.
                                <span style={{ fontWeight: 600 }}>
                                    <a href="/pdf/form-d4-part1.pdf" target="_blank" style={{ marginLeft: 20, marginRight: 10 }}>D-4 Worksheet - Part 1 (PDF)</a>
                                    <a href="/pdf/form-d4-instructions.pdf" target="_blank">D-4 Worksheet Instructions (PDF)</a>
                                </span>
                            </li>
                        </ol>
                    </li>
                </ol>

                <TableWrapper>
                    <thead>
                        <tr>
                            <th>Fee</th>
                            <th>Supporting Documents</th>
                            <th>Details</th>
                            <th>Rate</th>
                            <th className='amount'>Fee Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Physician Donor Nephrectomy</td>
                            <td>N/A</td>
                            <td>
                                ${this.props.physicianCharges.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}&nbsp;
                                <span style={{ cursor: 'pointer', textDecoration: 'underline', color: '#337ab7', fontWeight: 600 }} title='Click here to update the medicare participating amount...' onClick={this.props.onEditMedicareParticipating}>(Medicare Participating)</span>
                            </td>
                            <td>150%</td>
                            <td className='amount' style={{ paddingRight: 20 }}>${physicianChargesTotal.toLocaleString('en', { minimumFractionDigits: 2 })}</td>
                        </tr>

                        {anesthesiaChargeStatus == ChargeStatus.Disputed && (
                            <tr>
                                <td colSpan={5} className='text-danger' style={{ backgroundColor: '#eee', borderTop: '1px solid #ddd' }}>
                                    <div className='bg-danger' style={{ padding: 5, borderRadius: 4 }}><strong>This charge was disputed by {disputedBy}: {anesthesiaChargeComments}</strong></div>
                                </td>
                            </tr>
                        )}

                        <tr style={{ backgroundColor: '#eee' }}>
                            <td className={anesthesiaClassName}>Anesthesia - Enter ASA Units</td>
                            <td className={anesthesiaClassName}>
                                <UploadFile
                                    elementName="anesthesia-charges"
                                    valid={this.props.validAnesthesiaChargesFile}
                                    disable={disableAnesthesiaFileUpload}
                                    onSelectFile={this.handleAnesthesiaChargesFileChange}
                                />
                            </td>
                            <td className={anesthesiaClassName}>
                                {this.props.viewOnly == false ?
                                    <InputGroup style={{ width: 125 }}>
                                        <input type="text" name="asaUnits" className="form-control" style={{ border: this.props.validAsaUnitCount ? "1px solid #ccc" : "2px solid red" }} value={this.props.asaUnitCount} onChange={this.handleAsaUnitCountChange} />
                                        <InputGroup.Addon>
                                            Units
                                        </InputGroup.Addon>
                                    </InputGroup>
                                    :
                                    <InputGroup style={{ width: 125 }}>
                                        <InputGroup.Addon>{this.props.asaUnitCount}</InputGroup.Addon>
                                        <InputGroup.Addon>Units</InputGroup.Addon>
                                    </InputGroup>
                                }
                            </td>
                            <td className={anesthesiaClassName}>${this.props.asaUnitPrice}/ASA Unit</td>
                            <td className={anesthesiaClassName + ' amount'} style={{ paddingRight: 20 }}>{anesthesiaTotal.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                        </tr>

                        {this.props.anesthesiaChargesFile != '' && (
                            <tr style={{ backgroundColor: '#eee' }}>
                                <td className='no-border'></td>
                                <td className='no-border' colSpan={4}>Supporting document has been uploaded...</td>
                            </tr>
                        )}

                        {this.props.selectedAnesthesiaChargesFile != null && this.props.selectedAnesthesiaChargesFile.file != null && (
                            <tr style={{ backgroundColor: '#eee' }}>
                                <td colSpan={5} style={{ borderTop: '0 none', textAlign: 'center' }}><Label bsStyle='primary' style={{ fontSize: '100%' }}>Anesthesia file to upload: {this.props.selectedAnesthesiaChargesFile.file.name}</Label></td>
                            </tr>
                        )}

                        {hospitalChargeStatus == ChargeStatus.Disputed && (
                            <tr>
                                <td colSpan={5} className='text-danger' style={{ borderTop: '1px solid #ddd' }}>
                                    <div className='bg-danger' style={{ padding: 5, borderRadius: 4 }}><strong>This charge was disputed by {disputedBy}: {hospitalChargeComments}</strong></div>
                                </td>
                            </tr>
                        )}

                        <tr>
                            <td className={hospitalClassName}>Hospital Donor Nephrectomy</td>
                            <td className={hospitalClassName} colSpan={3}>
                                <UploadFile
                                    elementName="hospital-charges"
                                    valid={this.props.dirty ? this.props.validHospitalChargesFile : true}
                                    disable={this.props.viewOnly}
                                    onSelectFile={this.handleHospitalChargesFileChange}
                                />

                                <div style={{ fontSize: 12, marginTop: 3 }}>(Provide a copy of your most recently filed Medicare Cost Report, Worksheet D-4, Part I)</div>
                            </td>
                            <td className={hospitalClassName + ' amount'}>
                                {this.props.viewOnly == false ?
                                    <input type="text" className="form-control pull-right" style={{ width: '50%', textAlign: "right", border: this.props.dirty && !this.props.validHospitalCharges ? "2px solid red" : "1px solid #ccc" }} maxLength={24} value={hospitalCharges} onChange={this.handleHospitalChargesChange} />
                                    :
                                    <div style={{ padding: "6px 12px" }}>{this.props.hospitalCharges}</div>
                                }
                            </td>
                        </tr>

                        {this.props.hospitalChargesFile != '' && (
                            <tr>
                                <td className='no-border'></td>
                                <td className='no-border' colSpan={4}>Supporting document has been uploaded...</td>
                            </tr>
                        )}

                        {this.props.selectedHospitalChargesFile != null && this.props.selectedHospitalChargesFile.file != null && (
                            <tr>
                                <td colSpan={5} style={{ borderTop: '0 none', textAlign: 'center' }}><Label bsStyle='primary' style={{ fontSize: '100%' }}>Hospital Donor Nephrectomy file to upload: {this.props.selectedHospitalChargesFile.file.name}</Label></td>
                            </tr>
                        )}


                    </tbody>
                </TableWrapper>
            </>
        );
    }
}

export default Global;